import { RouterView } from 'vue-router';
const AllRefunds = () => import('@/pages/administration/AllRefunds.vue');
const AllAppointments = () => import('@/pages/frontdesk/AllAppointments.vue');
const CheckOutSurgeryAppointment = () =>
    import('@/pages/medicalServices/surgeries/checkOut/CheckOutSurgeryAppointment.vue');
const LeadsByInactiveSellers = () => import('@/pages/administration/LeadsByInactiveSellers.vue');
const RoutePermissions = () => import('@/pages/administration/RoutePermissions.vue');

const adminRoutes = [
    {
        path: 'admin',
        name: 'Administration',
        redirect: () => {
            return { path: '/admin/procedures' };
        },
        component: RouterView,
        meta: {
            title: 'Administration',
            public: false,
            icon: 'CogIcon',
        },
        children: [
            {
                path: 'appointments',
                name: 'AdminAppointments',
                component: AllAppointments,
                meta: {
                    menu: true,
                    title: 'Appointments',
                    permissionsAnyOf: [
                        'Permissions.SuperAdmin.Appointments.RollbackCompletedCosmetology',
                        'Permissions.SuperAdmin.Appointments.RollbackCompletedMassage',
                        'Permissions.SuperAdmin.Appointments.ChangeCheckOut',
                    ],
                },
                props: {
                    checkOutRoute: 'AdminChangeCheckOutSurgeryAppointment',
                },
            },
            {
                path: 'procedures',
                name: 'AdminRefunds',
                component: AllRefunds,
                meta: {
                    menu: true,
                    title: 'Refunds',
                    permissionsAnyOf: ['Permissions.SuperAdmin.Refunds.Update'],
                },
            },
            {
                path: 'inactives',
                name: 'AdminLeadsByInactiveSellers',
                component: LeadsByInactiveSellers,
                meta: {
                    menu: true,
                    title: 'LeadsByInactiveSellers',
                    permissionsAnyOf: ['Permissions.SuperAdmin.AssignedLeads.Search'],
                },
            },
            {
                path: 'appointments/change-check-out/:id/:patientId',
                name: 'AdminChangeCheckOutSurgeryAppointment',
                component: CheckOutSurgeryAppointment,
                meta: {
                    public: false,
                    title: 'CheckOut',
                    header: true,
                },
                props: {
                    editable: true,
                    route: 'AllAppointments',
                },
            },
            {
                path: 'route-permissions',
                name: 'RoutePermissions',
                component: RoutePermissions,
                meta: {
                    menu: true,
                    title: 'RoutePermissions',
                    permissionsAnyOf: ['Permissions.SuperAdmin.Permissions.Search'],
                },
            },
        ],
    },
];

export default adminRoutes;
